import PropTypes from "prop-types";
import React from "react";

import {Alert, Card, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row} from "reactstrap";

//redux
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import {useFormik} from "formik";

// actions
import {postOpsGenieOnboarding} from "../../store/actions";

// import images
import logo from "assets/images/logo.svg";

const OpsGenieOnboarding = props => {

  //meta title
  document.title = "OpsGenie Onboarding | Temperstack";

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      opsgenie_api_key: Yup.string().required("Please Enter Your OpsGenie API Key"),
    }),
    onSubmit: (values) => {
      dispatch(postOpsGenieOnboarding(values, props.router.navigate));
    }
  });

  const {error} = useSelector(state => ({
    error: state.Login.error,
  }));

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={12}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Please add OpsGenie API key to proceed</h5>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                        <img
                          src={logo}
                          alt=""
                          className="rounded-circle"
                          height="34"
                        />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}

                      <div className="mb-3">
                        <Label className="form-label">API Key</Label>
                        <Input
                          name="opsgenie_api_key"
                          className="form-control"
                          placeholder="API Key"
                          type="string"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.opsgenie_api_key || ""}
                          invalid={
                            validation.touched.opsgenie_api_key && validation.errors.opsgenie_api_key ? true : false
                          }
                        />
                        {validation.touched.opsgenie_api_key && validation.errors.opsgenie_api_key ? (
                          <FormFeedback type="invalid">{validation.errors.opsgenie_api_key}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Save
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(OpsGenieOnboarding);

OpsGenieOnboarding.propTypes = {
  history: PropTypes.object,
};
